import React from "react";
import { PropTypes } from "prop-types";

const FormSelect2 = ({
  field,
  name,
  options,
  form,
  label,
  id,
  onChange,
  handleBlur,
  placeholder
}) => {
  return (
    <div className="form-selec-main-group2">
      <div className="form-selec-group2">
        <label className="form-selec-label2">{label}</label>
        <select
          className="form-selec2"
          name={(field && field.name) || name}
          value={(field && field.value) || ""}
          onChange={(field && field.onChange) || onChange}
          onBlur={handleBlur}
          id={id}
          placeholder={placeholder}
        >
          <option value="" disabled selected className="default" >{placeholder}</option>
          {options &&
            options.map((option) => (
              <option key={option.id} value={option.id || ""}>
                {option.name}
              </option>
            ))}
        </select>
      </div>
      {form && form.touched[field.name] && form && form.errors[field.name] && (
        <small className="errors">{form.errors[field.name]}</small>
      )}
    </div>
  );
};

FormSelect2.propTypes = {
  options: PropTypes.array,
  field: PropTypes.object,
  form: PropTypes.object,
  onChange: PropTypes.func,
  handleBlur: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
  ])
}

export default FormSelect2;
